import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  IdItemProcessoIndicador: number | null,
  IdItemProcesso: number,
};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;

};


export const initialFiltersValues: State = {
  IdItemProcesso: 0,
  IdItemProcessoIndicador: 0,
};

export const useItemProcessosIndicadorFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));